export const WELCOME_GET_STARTED = 'WELCOME_GET_STARTED';
export const NHS_LOGIN_REGISTRATION_START = 'NHS_LOGIN_REGISTRATION_START';
export const NHS_LOGIN_REGISTRATION_FINISH = 'NHS_LOGIN_REGISTRATION_FINISH';
export const VIEW_MEDICATION = 'VIEW_MEDICATION';
export const REQUEST_MEDICATION = 'REQUEST_MEDICATION';
export const ORDER_MEDICATION_SUCCESS = 'ORDER_MEDICATION_SUCCESS';
export const CLIENT_SIDE_ERROR_ADD_CARD = 'CLIENT_SIDE_ERROR_ADD_CARD';
export const CLIENT_SIDE_ERROR_LOGIN_OAUTH = 'CLIENT_SIDE_ERROR_LOGIN_OAUTH';

export const FRIDGE_FULFILLMENT_SCREEN = 'FRIDGE_FULFILLMENT_SCREEN';
export const FRIDGE_FULFILLMENT_COLLECT = 'FRIDGE_FULFILLMENT_COLLECT';
export const FRIDGE_FULFILLMENT_DELIVERY = 'FRIDGE_FULFILLMENT_DELIVERY';
export const FRIDGE_FULFILLMENT_ROYALMAIL = 'FRIDGE_FULFILLMENT_ROYALMAIL';

export const CONTROLLED_DRUG_SCREEN = 'CONTROLLED_FULFILLMENT_SCREEN';
export const CONTROLLED_DRUG_COLLECT = 'CONTROLLED_FULFILLMENT_COLLECT';
export const CONTROLLED_DRUG_DELIVERY = 'CONTROLLED_FULFILLMENT_DELIVERY';
export const CONTROLLED_DRUG_ROYALMAIL = 'CONTROLLED_FULFILLMENT_ROYALMAIL';

export const GA_EVENTS = {
    FRIDGE_LINE: {
        FRIDGE_FULFILLMENT_SCREEN: {
            action: 'FRIDGE_FULFILLMENT_SCREEN',
            category: 'FRIDGE_LINES'
        },
        FRIDGE_FULFILLMENT_COLLECT: {
            action: 'FRIDGE_FULFILLMENT_COLLECT',
            category: 'FRIDGE_LINES'
        },
        FRIDGE_FULFILLMENT_DELIVERY: {
            action: 'FRIDGE_FULFILLMENT_DELIVERY',
            category: 'FRIDGE_LINES'
        },
        FRIDGE_FULFILLMENT_ROYALMAIL: {
            action: 'FRIDGE_FULFILLMENT_ROYALMAIL',
            category: 'FRIDGE_LINES'
        },

    },
    CONTROLLED_DRUG: {
        CONTROLLED_DRUG_SCREEN: {
            action: 'CONTROLLED_FULFILLMENT_SCREEN',
            category: 'CONTROLLED',
        },
        CONTROLLED_DRUG_COLLECT: {
            action: 'CONTROLLED_FULFILLMENT_COLLECT',
            category: 'CONTROLLED',
        },
        CONTROLLED_DRUG_DELIVERY: {
            action: 'CONTROLLED_FULFILLMENT_DELIVERY',
            category: 'CONTROLLED',
        },
        CONTROLLED_DRUG_ROYALMAIL: {
            action: 'CONTROLLED_FULFILLMENT_ROYALMAIL',
            category: 'CONTROLLED',
        },
        
    }
}